module.exports = __webpack_public_path__ + "static/img/academic3.4f514091.png";